// extracted by mini-css-extract-plugin
export default {"cardcontent":"DoughnutCard_cardcontent__tlkKU","overlay":"DoughnutCard_overlay__yM5-N"};